import React, { useState } from 'react'
import { FaCopy, FaCheck } from 'react-icons/fa'
import { Group } from '@chakra-ui/react'
import { Input, IconButton } from '@/components/lib'
import utils from '@/utils/utils'

export default function ReadOnlyCopyInput ({
  value,
  placeholder,
  copyValue,
  size = 'sm',
  buttonLabel = 'Copy',
  buttonProps
}) {
  const textToCopy = copyValue ?? value ?? ''
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    utils.copyToClipboard(textToCopy)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Group attached w='full'>
      <Input
        size={size}
        value={value ?? ''}
        placeholder={placeholder}
        readOnly
        bg='bg.surface'
        flex='1'
      />
      <IconButton
        size={size}
        variant='outline'
        onClick={handleCopy}
        aria-label={buttonLabel}
        colorPalette={copied ? 'green' : undefined}
        {...buttonProps}
      >
        {copied ? <FaCheck /> : <FaCopy />}
      </IconButton>
    </Group>
  )
}
